import { useMemo } from "react";
import type { StripeAddressElementOptions } from "@stripe/stripe-js";

export const useAddressElementAutocomplete =
  (): StripeAddressElementOptions["autocomplete"] =>
    useMemo(() => {
      const apiKey = window.GOOGLE_MAPS_API_KEY;

      if (!apiKey && process.env.NODE_ENV != "production") {
        console.warn(
          "Google Maps API key is not configured - address autocomplete will not work",
        );
      }

      return {
        apiKey: apiKey || "",
        mode: "google_maps_api",
      };
    }, []);
